// FrequencyStats Types

export interface RankingEntry {
  day: string;        // e.g., "Monday", "Tuesday", ..., "Sunday"
  hourRange: string;  // e.g., "0-1", "1-2", ..., "23-24"
  count: number;      // Number of receipts in this day-hourRange
  totalAmount: number;// Total amount paid for receipts in this day-hourRange
}

export interface ReceiptFrequencyRanking {
  byFrequency: RankingEntry[];   // Ranked by count descending
  byTotalAmount: RankingEntry[]; // Ranked by totalAmount descending
}

export interface HourBucket {
  count: number;       // Number of receipts in this hour range
  totalAmount: number; // Total amount paid for receipts in this hour range
}

export interface DayFrequency {
  averageTimeToPayMinutes: number; // Average time in minutes from time_started to local_timestamp for that day
  buckets: {
    [hourRange: string]: HourBucket;  // e.g., "0-1", "1-2", ..., "23-24"
  };
}

export interface WeeklyReceiptFrequency {
  [day: string]: DayFrequency;  // e.g., "Monday", "Tuesday", ..., "Sunday"
}

export interface FrequencyMetadata {
  totalReceipts: number;
  totalSessions: number;
  receiptsWithTimeTracking: number;
}

export interface ReceiptFrequencyResponse {
  frequency: WeeklyReceiptFrequency;
  overallAverageTimeToPayMinutes: number; // Overall average time in minutes from time_started to local_timestamp
  rankings: ReceiptFrequencyRanking;
  dateRange: {
    start: string; // ISO date string for the start of the range
    end: string;   // ISO date string for the end of the range
  };
  metadata: FrequencyMetadata;
}

export type DayOfWeek = 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday';

export type ViewMode = 'both' | 'frequency' | 'amount';

export const DAYS_OF_WEEK: DayOfWeek[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const DAY_LABELS: Record<DayOfWeek, string> = {
  Monday: 'Lunes',
  Tuesday: 'Martes',
  Wednesday: 'Miércoles',
  Thursday: 'Jueves',
  Friday: 'Viernes',
  Saturday: 'Sábado',
  Sunday: 'Domingo',
};

export const DAY_ABBREVIATIONS: Record<DayOfWeek, string> = {
  Monday: 'L',
  Tuesday: 'M',
  Wednesday: 'X',
  Thursday: 'J',
  Friday: 'V',
  Saturday: 'S',
  Sunday: 'D',
};
